import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {endUserSelector, setFilter} from '../../../../redux/slices/endUserSlices'
import * as TableUI from '../../../../components/Table/Table'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filter} = useAppSelector(endUserSelector)
  const dispatch = useAppDispatch()

  return (
    <TableUI.TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('End User Name')}
          onChange={(e: any) => dispatch(setFilter({...filter, name: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Address')}
          value={filter?.address ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, address: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('City')}
          value={filter?.city_name ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, city_name: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Province')}
          value={filter?.province_name ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, province_name: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Phone Number')}
          value={filter?.phone ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, phone: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Email')}
          value={filter?.email ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, email: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('segment')}
          value={filter?.segment_name ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, segment_name: e.target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Bidang Usaha')}
          value={filter?.business_field ?? ''}
          onChange={(e: any) => dispatch(setFilter({...filter, business_field: e.target.value}))}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TableUI.TRowFilter>
  )
})
